// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useState } from 'react';
import { useStableCallback } from '@cloudscape-design/component-toolkit/internal';
export function useOwnBreadcrumbsProps() {
    const [breadcrumbs, setBreadcrumbs] = useState(null);
    const reportOwnBreadcrumbsProps = useStableCallback((props) => {
        setBreadcrumbs(props);
        return {
            update: setBreadcrumbs,
            cleanup: () => setBreadcrumbs(null),
        };
    });
    return { breadcrumbs, reportOwnBreadcrumbsProps };
}
//# sourceMappingURL=use-own-breadcrumbs-props.js.map